<template>
    <div class="grcform">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>
        <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>

        <div class="grc_fullwidth_lane">
            <div class="grc_maincont_lane" style="padding-left: 4px;">
              <div class="grc_sectionheader" style="margin-top:10px; margin-bottom:10px;">
                  <span class="line color1">
                    <span class="title_general" style="padding-left:10px !important;">
                      {{title}}
                      </span>
                  </span>
              </div>
            </div>
        </div>

        <div class="grc_fullwidth_lane">
        <div class="grc_maincont_lane" style="padding:10px;" v-show="Tagkod==-1">
            <b>A hivatkozási paraméterek elévültek!</b>
        </div>
        <div class="grc_maincont_lane" style="padding:10px; font-size: 16px; line-height: 24px;" v-show="Tagkod==-2" v-html="tiltva_szoveg">
            
        </div>


        <div class="grc_maincont_lane" style="padding:10px;" v-show="Tagkod>0">

            <div class="main_col_cont sikeres_text" v-show="Mentve" v-html="sikeres_text">
            </div>

            <div class="main_col_cont" v-show="Mentve==false">

                <div class="main_col cont_shadow">

                    <div class="innerform" v-show="innerformid==1">
                        <div class="infotext" v-html="infotext1" />

                        <div class="innerform_pad">
                            <div class="section_header" ref="nyilatk_chk_header" style="margin-bottom: 8px;">Nyilatkozat</div>

                            <table style="width:100%; margin-top:20px; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                            <tr style="height: 32px;">
                                <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkNemKozszereplo" v-on:valuechanged="chkKozszereplo_changed(2)" /></td>
                                <td valign="top" class="chkKozszerplo">Nem vagyok kiemelt közszereplő</td>
                            </tr>
                            <tr style="height: 32px;">
                                <td style="width:45px;" valign="top"><GrcCheckboxMobile ref="chkKozszereplo" v-on:valuechanged="chkKozszereplo_changed(1)"  /></td>
                                <td valign="top" class="chkKozszerplo">Kiemelt közszereplő vagyok</td>
                            </tr>
                            </table>        

                            <div class="section_header" style="margin-bottom: 8px;">Adatellenőrzés, adatmódosítás</div>


                            <div class="htart_table">
                                <div class="htart_tablerow">
                                    <div class="htart_col1">
                                        <GrcText ref="txtNev"
                                        grc_labeltext="Név:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtSzuletesiNev');"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="htart_table">
                                <div class="htart_tablerow">
                                    <div class="htart_col2">
                                        <GrcText ref="txtSzuletesiNev"
                                        grc_labeltext="Születési név:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtAnyjaNeve');"
                                        />
                                    </div>
                                    <div class="htart_col2">
                                        <GrcText ref="txtAnyjaNeve"
                                        grc_labeltext="Anyja neve:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtSzuletesiHely');"
                                        />
                                    </div>
                                </div>

                                <div class="htart_tablerow">
                                    <div class="htart_col2">
                                        <GrcText ref="txtSzuletesiHely"
                                        grc_labeltext="Születési hely:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtSzuletesiIdo');"
                                        />
                                    </div>
                                    <div class="htart_col2">
                                        <GrcDate ref="txtSzuletesiIdo" v-model="SzuletesiIdo" grc_dateformat="ymd" grc_sep="." 
                                        grc_labeltext="Születési idő:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtIrszam');"
                                        v-on:dropdownopened="SetPopupRef('txtSzuletesiIdo')"
                                        v-on:dropdownclosed="SetPopupRef('')"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="infotext" style="text-align:center; font-weight:500; margin: 15px 0px 5px 0px;">- Állandó lakcím -</div>

                            <div class="htart_table">
                                <div class="htart_tablerow">
                                    <div class="htart_col2">
                                        <GrcText ref="txtIrszam"
                                        grc_labeltext="Irányítószám:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtTelepules');"
                                        />
                                    </div>
                                    <div class="htart_col2">
                                        <GrcText ref="txtTelepules"
                                        grc_labeltext="Település:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtKozterNev');"
                                        />
                                    </div>
                                </div>
                                <div class="htart_tablerow">
                                    <div class="htart_col2">
                                        <GrcText ref="txtKozterNev"
                                        grc_labeltext="Közterület:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtKozterJelleg');"
                                        />
                                    </div>
                                    <div class="htart_col2">
                                        <GrcText ref="txtKozterJelleg"
                                        grc_labeltext="Közterület jellege:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtHazszam');"
                                        />
                                    </div>
                                </div>
                                <div class="htart_tablerow">
                                    <div class="htart_col2">
                                        <GrcText ref="txtHazszam"
                                        grc_labeltext="Házsszám:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtEpulet');"
                                        />
                                    </div>
                                    <div class="htart_col2">
                                        <GrcText ref="txtEpulet"
                                        grc_labeltext="Épület:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtLepcsohaz');"
                                        />
                                    </div>
                                </div>
                                <div class="htart_tablerow">
                                    <div class="htart_col2">
                                        <GrcText ref="txtLepcsohaz"
                                        grc_labeltext="Lépcsőház:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtEmelet');"
                                        />
                                    </div>
                                    <div class="htart_col2">
                                        <GrcText ref="txtEmelet"
                                        grc_labeltext="Emelet:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('txtAjto');"
                                        />
                                    </div>
                                </div>
                                <div class="htart_tablerow">
                                    <div class="htart_col2">
                                        <GrcText ref="txtAjto"
                                        grc_labeltext="Ajtó:"
                                        grc_placeholder="..."
                                        grc_labelmode="" grc_labelwidth="200px" 
                                        grc_readonly="false"
                                        v-on:grc-keydown-enter="SetControlToFocus('');"
                                        />
                                    </div>
                                    <div class="htart_col2">&nbsp;</div>
                                </div>
                            </div>

                            <div class="btn_cont" style="margin-top:50px; border-top: solid 0px #ccc; text-align:center;">
                                <GrcButton ref="btnStepTo_1_2" grc_text="Tovább" @grc-click="StepTo(2)" grc_readonly="false" 
                                grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="120px"
                                grc_buttonpos="right"
                                grc_righticon="<i class='fas fa-chevron-right'></i>"
                                style="display:inline-block;" />        
                            </div>





                        </div>
                    </div>

                    <div class="innerform" v-show="innerformid==2">

                        <div class="innerform_pad">

                            <div class="section_header" style="margin-top: 10px; margin-bottom:10px;">Nyilatkozat kitöltése és feltöltése</div>

                            <div class="colcontent">
                                <div class="colcontent_col2">
                                    <div class="nyilatk_info" style="color:#323232; font-weight:normal; text-align:left;">
                                        Kérjük, töltsd ki az „Adatközlő adatlap és közszereplő nyilatkozat” mindkét oldalát
                                    </div>

                                    <div class="btn_cont" style="text-align: center;">
                                        <div class="btn grc-noselect" @click="DisplayNyilatkozat(1)">
                                            <i class="fas fa-file-alt btn_icon" style="font-size: 22px; margin-right:14px; vertical-align: middle;"></i>
                                            <span class="btn_text">Közszereplői nyilatkozat letöltése</span>
                                        </div>
                                    </div>

                                </div>
                                <div class="colcontent_col2">
                                    <GrcDocMultiSelect ref="DMS_Nyilatkozat" grc_shownoti="false" grc_maxfiles="1" grc_allowed_extensions="pdf, jpg, png" />
                                </div>
                            </div>

                            <div class="btn_cont" style="margin-top:50px; border-top: solid 0px #ccc; text-align:center;">

                                <GrcButton ref="btnStepTo_2_1" grc_text="Vissza" @grc-click="StepTo(1)" grc_readonly="false" 
                                grc_color="grey" grc_shadow="false" grc_radius="2px" grc_width="120px"
                                grc_buttonpos="left"
                                grc_lefticon="<i class='fas fa-chevron-left'></i>"
                                style="display:inline-block; margin-right:20px;" />        

                                <GrcButton ref="btnStepTo_2_3" grc_text="Tovább" @grc-click="StepTo(3)" grc_readonly="false" 
                                grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="120px"
                                grc_buttonpos="right"
                                grc_righticon="<i class='fas fa-chevron-right'></i>"
                                style="display:inline-block;" />        
                            </div>

                        </div>
                    </div>



                    <div class="innerform" v-show="innerformid==3">

                        <div class="innerform_pad">

                            <div class="section_header" style="margin-top: 10px; margin-bottom:10px;">Azonosító dokumentumok megadása</div>

                            <GrcCombo ref="DOKTIPUS" v-model="DokTipusID" grc_labeltext="Dokumentum típusa:"
                            grc_labelmode="above" grc_labelwidth="200px" grc_dropdownminwidth="300"  
                            grc_keyfield="id" grc_displayfield="Megnevezes"
                            v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                            v-on:dropdownopened="SetPopupRef('DOKTIPUS')"
                            v-on:dropdownclosed="SetPopupRef('')"
                            v-on:innerindexbroadcast="DOKTIPUS_InnerIndexBroadcasted"
                            v-on:grc-keydown-enter="SetControlToFocus('');"
                            style="margin-bottom:10px;"
                            />

                            <div class="dok_cont" v-show="DokTipusID==1">

                                <div class="colcontent">
                                    <div class="colcontent_col3">
                                        <div class="dok_label"><table class="dok_label_text" cellspacing="0" cellpadding="0"><tr><td valign="center">Okmány első oldala:
                                        <br>A személyazonosító okmányon lévő arckép és aláírás nem szükséges az azonosítás elvégzéséhez    
                                        </td></tr></table></div>
                                        <GrcDocMultiSelect ref="DMS_1_1" grc_shownoti="false" grc_maxfiles="1" grc_allowed_extensions="pdf, jpg, png" />
                                    </div>
                                    <div class="colcontent_col3">
                                        <div class="dok_label"><table class="dok_label_text" cellspacing="0" cellpadding="0"><tr><td valign="center">Okmány második oldala:</td></tr></table></div>
                                        <GrcDocMultiSelect ref="DMS_1_2" grc_shownoti="false" grc_maxfiles="1" grc_allowed_extensions="pdf, jpg, png" />
                                    </div>
                                    <div class="colcontent_col3">
                                        <div class="dok_label"><table class="dok_label_text" cellspacing="0" cellpadding="0"><tr><td valign="center">Lakcímkártya azon oldala, ahol a cím adatok szerepelnek:</td></tr></table></div>
                                        <GrcDocMultiSelect ref="DMS_1_3" grc_shownoti="false" grc_maxfiles="1" grc_allowed_extensions="pdf, jpg, png" />
                                    </div>
                                </div>

                            </div>

                            <div class="dok_cont" v-show="DokTipusID==2">
                                <div class="colcontent">
                                    <div class="colcontent_col3">
                                        <div class="dok_label"><table class="dok_label_text" cellspacing="0" cellpadding="0"><tr><td valign="center">Okmány első oldala:
                                        <br>A személyazonosító okmányon lévő arckép és aláírás nem szükséges az azonosítás elvégzéséhez
                                        </td></tr></table></div>
                                        <GrcDocMultiSelect ref="DMS_2_1" grc_shownoti="false" grc_maxfiles="1" grc_allowed_extensions="pdf, jpg, png" />
                                    </div>
                                    <div class="colcontent_col3">
                                        <div class="dok_label"><table class="dok_label_text" cellspacing="0" cellpadding="0"><tr><td valign="center">Okmány második oldala:</td></tr></table></div>
                                        <GrcDocMultiSelect ref="DMS_2_2" grc_shownoti="false" grc_maxfiles="1" grc_allowed_extensions="pdf, jpg, png" />
                                    </div>
                                    <div class="colcontent_col3">
                                        <div class="dok_label"><table class="dok_label_text" cellspacing="0" cellpadding="0"><tr><td valign="center">Lakcímkártya azon oldala, ahol a cím adatok szerepelnek:</td></tr></table></div>
                                        <GrcDocMultiSelect ref="DMS_2_3" grc_shownoti="false" grc_maxfiles="1" grc_allowed_extensions="pdf, jpg, png" />
                                    </div>
                                </div>
                            </div>

                            <div class="dok_cont" v-show="DokTipusID==3">
                                <div class="colcontent">
                                    <div class="colcontent_col2">
                                        <div class="dok_label"><table class="dok_label_text" cellspacing="0" cellpadding="0"><tr><td valign="center">Okmány fényképes oldala:
                                        <br>A személyazonosító okmányon lévő arckép és aláírás nem szükséges az azonosítás elvégzéséhez
                                        </td></tr></table></div>
                                        <GrcDocMultiSelect ref="DMS_3_1" grc_shownoti="false" grc_maxfiles="1" grc_allowed_extensions="pdf, jpg, png" />
                                    </div>
                                    <div class="colcontent_col2">
                                        <div class="dok_label"><table class="dok_label_text" cellspacing="0" cellpadding="0"><tr><td valign="center">Lakcímkártya azon oldala, ahol a cím adatok szerepelnek:</td></tr></table></div>
                                        <GrcDocMultiSelect ref="DMS_3_2" grc_shownoti="false" grc_maxfiles="1" grc_allowed_extensions="pdf, jpg, png" />
                                    </div>
                                </div>
                            </div>

                            <div class="dok_cont" v-show="DokTipusID==4">
                                <div class="colcontent">
                                    <div class="colcontent_col2">
                                        <div class="dok_label"><table class="dok_label_text" cellspacing="0" cellpadding="0"><tr><td valign="center">Okmány fényképes oldala (1-2 oldal):
                                        <br>A személyazonosító okmányon lévő arckép és aláírás nem szükséges az azonosítás elvégzéséhez
                                        </td></tr></table></div>
                                        <GrcDocMultiSelect ref="DMS_4_1" grc_shownoti="false" grc_maxfiles="1" grc_allowed_extensions="pdf, jpg, png" />
                                    </div>
                                    <div class="colcontent_col2">
                                        <div class="dok_label"><table class="dok_label_text" cellspacing="0" cellpadding="0"><tr><td valign="center">Okmány lejárati dátumát, címét tartalmazó oldala (3-4 oldal):</td></tr></table></div>
                                        <GrcDocMultiSelect ref="DMS_4_2" grc_shownoti="false" grc_maxfiles="1" grc_allowed_extensions="pdf, jpg, png" />
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div class="btn_cont" style="margin-top:50px; border-top: solid 0px #ccc; text-align:center;">

                            <GrcButton ref="btnStepTo_3_2" grc_text="Vissza" @grc-click="StepTo(2)" grc_readonly="false" 
                            grc_color="grey" grc_shadow="false" grc_radius="2px" grc_width="120px"
                            grc_buttonpos="left"
                            grc_lefticon="<i class='fas fa-chevron-left'></i>"
                            style="display:inline-block; margin-right:20px;" />        

                            <GrcButton ref="btnStepTo_3_4" grc_text="Adatok feltöltése" @grc-click="Step4_check" grc_readonly="false" 
                            grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="200px"
                            grc_buttonpos="left"
                            grc_lefticon="<i class='fas fa-check'></i>"
                            style="display:inline-block;" />        
                        </div>


                    </div>
                </div>
            </div>
            





        </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'
import GrcDocMultiSelect from '../GrcComponents/GrcDocMultiSelect.vue'



export default {
  name: 'frmPmt',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcDate,
      GrcNum,
      GrcCheckboxMobile,
      GrcDocDisplayer,
      GrcDocMultiSelect,
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmPmt",
            gPopupControlName:"",

            param_tagkod:0,
            param_ct:"",
            param_cv:"",

            Mentve:false,
            sikeres_text:"",

            Tagkod:0,

            PdfData_Kozszereplo: "",
            PdfData_NemKozszereplo: "",

            MaxWidth:0,
            MaxHeight:0,

            Nev:"",

            innerformid:1,
            title:"",


            infotext1:"",
            btnTovabb1_text:"Tovább",

            DokTipusID:0,
            DOKTIPUSLIST:[],

            TAGADAT: [],
            SzuletesiIdo:"",

            tiltva_szoveg:"",
            
      }
  },
  model: {
  },  
  methods:{

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmPmt", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
    },

    chkKozszereplo_changed(pIndex)
    {
        if (pIndex == 1)
        {
            if (this.$refs.chkKozszereplo.GetValue() == 1) { this.$refs.chkNemKozszereplo.SetValue(0); }
        }
        if (pIndex == 2)
        {
            if (this.$refs.chkNemKozszereplo.GetValue() == 1) { this.$refs.chkKozszereplo.SetValue(0); }
        }
    },

    HideErrors_Tagadat()
    {
        this.$refs.txtNev.HideError();
        this.$refs.txtSzuletesiHely.HideError();
        this.$refs.txtSzuletesiIdo.HideError();
        this.$refs.txtIrszam.HideError();
        this.$refs.txtTelepules.HideError();
        this.$refs.txtKozterNev.HideError();
        this.$refs.txtKozterJelleg.HideError();
        this.$refs.txtHazszam.HideError();
    },

    async CheckTagAdat()
    {
        if (this.$refs.chkKozszereplo.GetValue()==1)
        {
            let DT = this.GetTextBookItem("kozszereplo_tiltas_text");

            var DialogResult = "";
            var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), DT);             
            p.height = 500;
            p.width = 600;
            p.padding_top = -1; //20;
            if (grccomp_getScreenSize().width < 400) { p.width = 300; }
            await this.$refs.Dialog.ShowDialog(p).then(res => 
            { 
                DialogResult = res; 
            });               

            return;
        }

        this.HideErrors_Tagadat();

        var ErrorCompName = "";

        if (this.$refs.txtNev.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtNev"; }
          this.$refs.txtNev.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtAnyjaNeve.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtAnyjaNeve"; }
          this.$refs.txtAnyjaNeve.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtSzuletesiHely.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtSzuletesiHely"; }
          this.$refs.txtSzuletesiHely.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtSzuletesiIdo.IsValid(false) == false)
        {
          if (ErrorCompName == "") { ErrorCompName = "txtSzuletesiIdo"; }
          this.$refs.txtSzuletesiIdo.ShowError("A dátum nincs megadva vagy helytelen!");
        }

        if (this.$refs.txtIrszam.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtIrszam"; }
          this.$refs.txtIrszam.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtTelepules.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtTelepules"; }
          this.$refs.txtTelepules.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtKozterNev.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtKozterNev"; }
          this.$refs.txtKozterNev.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtKozterJelleg.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtKozterJelleg"; }
          this.$refs.txtKozterJelleg.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtHazszam.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtHazszam"; }
          this.$refs.txtHazszam.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if ((this.$refs.chkKozszereplo.GetValue()==0) && (this.$refs.chkNemKozszereplo.GetValue()==0))
        {
            let el = grccomp_findPos("nyilatk_chk_header");
            window.scrollTo({left:0, top:el.top, behavior: 'smooth'});

            this.ShowInfoDialog("Kérjük válaszd ki a közszereplői státuszt!", "200");

            return;
        }
        else
        {
            if (ErrorCompName != "")
            {
                this.SetControlToFocus(ErrorCompName);
                return;
            }
        }

        this.TAGADAT[0].Nev = this.$refs.txtNev.GetText();
        this.TAGADAT[0].SzuletesiNev = this.$refs.txtSzuletesiNev.GetText();
        this.TAGADAT[0].AnyjaNeve = this.$refs.txtAnyjaNeve.GetText();
        this.TAGADAT[0].SzuletesiHely = this.$refs.txtSzuletesiHely.GetText();
        this.TAGADAT[0].SzuletesiIdo = this.$refs.txtSzuletesiIdo.GetText();
        this.TAGADAT[0].Irszam = this.$refs.txtIrszam.GetText();
        this.TAGADAT[0].Telepules = this.$refs.txtTelepules.GetText();
        this.TAGADAT[0].KozterNev = this.$refs.txtKozterNev.GetText();
        this.TAGADAT[0].KozterJelleg = this.$refs.txtKozterJelleg.GetText();

        this.TAGADAT[0].Hazszam = this.$refs.txtHazszam.GetText();
        this.TAGADAT[0].Epulet = this.$refs.txtEpulet.GetText();
        this.TAGADAT[0].Lepcsohaz = this.$refs.txtLepcsohaz.GetText();
        this.TAGADAT[0].Emelet = this.$refs.txtEmelet.GetText();
        this.TAGADAT[0].Ajto = this.$refs.txtAjto.GetText();

        if (this.$refs.chkKozszereplo.GetValue() == 1) 
        { 
            this.$refs.DMS_Nyilatkozat.ClearAll();
            this.innerformid = 2; 
        }
        else 
        {
            await this.MakeNemKozszereploNyilatkozat();
            this.innerformid = 3; 
        }

        this.scrollToTop();
    },




    StepTo(pFormTo)
    {
        if ((this.innerformid == 1) && (pFormTo==2))
        {
            this.CheckTagAdat();
            return;
        }

        if ((this.innerformid == 2) && (pFormTo==1))
        {
            this.$refs.DMS_Nyilatkozat.ClearAll();
            this.innerformid = 1;
            return;
        }

        if ((this.innerformid == 2) && (pFormTo==3))
        {
            if (this.$refs.DMS_Nyilatkozat.GetFileCount() == 0)
            {
                this.ShowInfoDialog("Kérjük töltsd fel az aláírt nyilatkozatot!", "200");
                return;
            }

            this.innerformid = 3;
            return;
        }

        if ((this.innerformid == 3) && (pFormTo==2))
        {
            if (this.$refs.chkNemKozszereplo.GetValue() == 1) { this.innerformid = 1; }
            else { this.innerformid = 2; }
            return;
        }

    },



    Step4_check()
    {
        if (this.$refs.DMS_Nyilatkozat.GetFileCount() == 0)
        {
            this.ShowInfoDialog("Kérjük válaszd ki az aláírt nyilatkozatot!", "200");
            return;
        }

        var pDokTipusID = this.$refs.DOKTIPUS.GetValue();

        if (pDokTipusID == 0)
        {
            this.ShowInfoDialog("A dokumentum típus megadása kötelező!", "200");
            return;
        }

        if (pDokTipusID == 1)   // új személyi
        {
            if ((this.$refs.DMS_1_1.GetFileCount() == 0) || (this.$refs.DMS_1_2.GetFileCount() == 0) || (this.$refs.DMS_1_3.GetFileCount() == 0) )
            {
                this.ShowInfoDialog("Kérjük válaszd ki a feltöltendő fájlokat!", "200");
                return;
            }
        }

        if (pDokTipusID == 2)   // jogositvany
        {
            if ((this.$refs.DMS_2_1.GetFileCount() == 0) || (this.$refs.DMS_2_2.GetFileCount() == 0) || (this.$refs.DMS_2_3.GetFileCount() == 0) )
            {
                this.ShowInfoDialog("Kérjük válaszd ki a feltöltendő fájlokat!", "200");
                return;
            }
        }

        if (pDokTipusID == 3)   // utlevel
        {
            if ((this.$refs.DMS_3_1.GetFileCount() == 0) || (this.$refs.DMS_3_2.GetFileCount() == 0) )
            {
                this.ShowInfoDialog("Kérjük válaszd ki a feltöltendő fájlokat!", "200");
                return;
            }
        }

        if (pDokTipusID == 4)   // regi szemelyi
        {
            if ((this.$refs.DMS_4_1.GetFileCount() == 0) || (this.$refs.DMS_4_2.GetFileCount() == 0) )
            {
                this.ShowInfoDialog("Kérjük válaszd ki a feltöltendő fájlokat!", "200");
                return;
            }
        }


        this.Mentes();
    },

    async Mentes()
    {
        this.$refs.GRCDB.ShowLoading(false);

        var pDokTipusID = this.$refs.DOKTIPUS.GetValue();

        var pUploadID_0 = "";
        var pUploadID_1 = "";
        var pUploadID_2 = "";
        var pUploadID_3 = "";
        var UploadRes;

        UploadRes = await this.$refs.DMS_Nyilatkozat.UploadFiles(2, false);
        if (UploadRes.Success == false) 
        {  
            this.$refs.GRCDB.HideLoading();
            this.ShowInfoDialog("Hiba a fájlok feltöltésekor! (hibakód: 0)", "200");
            return;
        }
        pUploadID_0 = UploadRes.UploadID;

        if (pDokTipusID == 1)
        {
            UploadRes = await this.$refs.DMS_1_1.UploadFiles(2, false);
            if (UploadRes.Success == false) 
            {  
                this.$refs.GRCDB.HideLoading();
                this.ShowInfoDialog("Hiba a fájlok feltöltésekor! (hibakód: 1)", "200");
                return;
            }
            pUploadID_1 = UploadRes.UploadID;

            UploadRes = await this.$refs.DMS_1_2.UploadFiles(2, false);
            if (UploadRes.Success == false) 
            {  
                this.$refs.GRCDB.HideLoading();
                this.ShowInfoDialog("Hiba a fájlok feltöltésekor! (hibakód: 1)", "200");
                return;
            }
            pUploadID_2 = UploadRes.UploadID;

            UploadRes = await this.$refs.DMS_1_3.UploadFiles(2, false);
            if (UploadRes.Success == false) 
            {  
                this.$refs.GRCDB.HideLoading();
                this.ShowInfoDialog("Hiba a fájlok feltöltésekor! (hibakód: 1)", "200");
                return;
            }
            pUploadID_3 = UploadRes.UploadID;
        }

        if (pDokTipusID == 2)
        {
            UploadRes = await this.$refs.DMS_2_1.UploadFiles(2, false);
            if (UploadRes.Success == false) 
            {  
                this.$refs.GRCDB.HideLoading();
                this.ShowInfoDialog("Hiba a fájlok feltöltésekor! (hibakód: 2)", "200");
                return;
            }
            pUploadID_1 = UploadRes.UploadID;

            UploadRes = await this.$refs.DMS_2_2.UploadFiles(2, false);
            if (UploadRes.Success == false) 
            {  
                this.$refs.GRCDB.HideLoading();
                this.ShowInfoDialog("Hiba a fájlok feltöltésekor! (hibakód: 2)", "200");
                return;
            }
            pUploadID_2 = UploadRes.UploadID;

            UploadRes = await this.$refs.DMS_2_3.UploadFiles(2, false);
            if (UploadRes.Success == false) 
            {  
                this.$refs.GRCDB.HideLoading();
                this.ShowInfoDialog("Hiba a fájlok feltöltésekor! (hibakód: 2)", "200");
                return;
            }
            pUploadID_3 = UploadRes.UploadID;
        }

        if (pDokTipusID == 3)
        {
            UploadRes = await this.$refs.DMS_3_1.UploadFiles(2, false);
            if (UploadRes.Success == false) 
            {  
                this.$refs.GRCDB.HideLoading();
                this.ShowInfoDialog("Hiba a fájlok feltöltésekor! (hibakód: 3)", "200");
                return;
            }
            pUploadID_1 = UploadRes.UploadID;

            UploadRes = await this.$refs.DMS_3_2.UploadFiles(2, false);
            if (UploadRes.Success == false) 
            {  
                this.$refs.GRCDB.HideLoading();
                this.ShowInfoDialog("Hiba a fájlok feltöltésekor! (hibakód: 3)", "200");
                return;
            }
            pUploadID_2 = UploadRes.UploadID;
        }

        if (pDokTipusID == 4)
        {
            UploadRes = await this.$refs.DMS_4_1.UploadFiles(2, false);
            if (UploadRes.Success == false) 
            {  
                this.$refs.GRCDB.HideLoading();
                this.ShowInfoDialog("Hiba a fájlok feltöltésekor! (hibakód: 4)", "200");
                return;
            }
            pUploadID_1 = UploadRes.UploadID;

            UploadRes = await this.$refs.DMS_4_2.UploadFiles(2, false);
            if (UploadRes.Success == false) 
            {  
                this.$refs.GRCDB.HideLoading();
                this.ShowInfoDialog("Hiba a fájlok feltöltésekor! (hibakód: 4)", "200");
                return;
            }
            pUploadID_2 = UploadRes.UploadID;
        }


        
        
        var QP = {
            iTagkod: this.param_tagkod,
            sCreateTime: this.param_ct,
            sHash: this.param_cv,
            iDokTipusID: pDokTipusID,
            sUploadID_0: pUploadID_0,
            sUploadID_1: pUploadID_1,
            sUploadID_2: pUploadID_2,
            sUploadID_3: pUploadID_3,
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Save_V3", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        this.$refs.GRCDB.HideLoading();

        //console.log(Q.RESULT[0].NyilatkozatAdat);

        //var docresultteszt = this.$refs.DocDisplayer.ShowFile(Q.RESULT[0].NyilatkozatAdat, "pmtteszt.pdf", "pmtteszt.pdf");

        if (Q.RESULT[0].intResult == 1)
        {
            this.Mentve = true;
        }
        else
        {
            this.ShowInfoDialog(Q.RESULT[0].strResult, "200");
        }
    },


    SetLang()
    {
        this.title = this.GetTextBookItem("title");
        this.infotext1 = this.GetTextBookItem("infotext1_v2");
        this.btnTovabb1_text = this.GetTextBookItem("btnTovabb1_text");

        this.sikeres_text = this.GetTextBookItem("sikeres_text");

        this.Init();
    },

      HideErrors()
      {
        //this.$refs.ErrorBox.HideError();
        this.$refs.DOKTIPUS.HideError();
      },

    DOKTIPUS_InnerIndexBroadcasted(pIndex)
    {
        if (this.DokTipusID != this.DOKTIPUSLIST[pIndex].id)
        {
            this.$refs.DOKTIPUS.HideError();
        }

        this.DokTipusID = this.DOKTIPUSLIST[pIndex].id;
    },

    async MakeNemKozszereploNyilatkozat()
    {
        this.$refs.DMS_Nyilatkozat.ClearAll();
        var docdata = await this.MakeNyilatkozat(2);
        await this.$refs.DMS_Nyilatkozat.AddFileFromOutside("pmt_nyilatkozat.pdf", docdata, "");
    },

    async MakeNyilatkozat(pTipus)
    {
        var PdfData = "";
        var PdfParams = "";

        if (pTipus == 1)
        {
            PdfData = this.PdfData_Kozszereplo;
            PdfParams = this.TAGADAT[0].SablonParam_Kozszereplo;
        }

        if (pTipus == 2)
        {
            PdfData = this.PdfData_NemKozszereplo;
            PdfParams = this.TAGADAT[0].SablonParam_NemKozszereplo;
        }

        PdfParams = PdfParams.replaceAll("[NEV]", this.TAGADAT[0].Nev.toUpperCase());
        PdfParams = PdfParams.replaceAll("[SZULETESINEV]", this.TAGADAT[0].SzuletesiNev.toUpperCase());
        PdfParams = PdfParams.replaceAll("[ANYJANEVE]", this.TAGADAT[0].AnyjaNeve.toUpperCase());
        PdfParams = PdfParams.replaceAll("[SZULETESIHELY]", this.TAGADAT[0].SzuletesiHely.toUpperCase());
        PdfParams = PdfParams.replaceAll("[SZULDATUMEV]", this.TAGADAT[0].SzuletesiIdo.substr(0,4));
        PdfParams = PdfParams.replaceAll("[SZULDATUMHO]", this.TAGADAT[0].SzuletesiIdo.substr(5,2));
        PdfParams = PdfParams.replaceAll("[SZULDATUMNAP]", this.TAGADAT[0].SzuletesiIdo.substr(8,2));

        PdfParams = PdfParams.replaceAll("[IRSZAM]", this.TAGADAT[0].Irszam.toUpperCase());
        PdfParams = PdfParams.replaceAll("[VAROS]", this.TAGADAT[0].Telepules.toUpperCase());
        PdfParams = PdfParams.replaceAll("[KOZTERNEV]", this.TAGADAT[0].KozterNev.toUpperCase());
        PdfParams = PdfParams.replaceAll("[KOZTERJELLEG]", this.TAGADAT[0].KozterJelleg.toUpperCase());
        PdfParams = PdfParams.replaceAll("[HAZSZAM]", this.TAGADAT[0].Hazszam.toUpperCase());
        PdfParams = PdfParams.replaceAll("[EPULET]", this.TAGADAT[0].Epulet.toUpperCase());
        PdfParams = PdfParams.replaceAll("[LEPCSOHAZ]", this.TAGADAT[0].Lepcsohaz.toUpperCase());
        PdfParams = PdfParams.replaceAll("[EMELET]", this.TAGADAT[0].Emelet.toUpperCase());
        PdfParams = PdfParams.replaceAll("[AJTO]", this.TAGADAT[0].Ajto.toUpperCase());


        if (PdfParams != "")
        {
            this.$refs.GRCDB.ShowLoading(false);
            
            var QP = {
                sSourcePdfBase64: PdfData,
                sDatasetXml: PdfParams,
            };
            var Q;
            await this.$refs.GRCDB.GetData("FillPdfForm", QP).then(res => { Q = res; });

            if (Q.APPERR[0].ERR != "")
            {
                this.$refs.GRCDB.HideLoading();
                if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
                {
                    this.$emit("handlecommerror", Q.APPERR[0].ERR);
                }
                else
                {            
                    this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
                }
                return;
            }

            this.$refs.GRCDB.HideLoading();

            PdfData = Q.RESULT[0].PdfData;

        } // PdfFieldData != ""

        return PdfData;

    },

    async DisplayNyilatkozat(pTipus)
    {
        var docb64 = await this.MakeNyilatkozat(pTipus);
        //console.log(docb64);
        var docfn = "pmt_nyilatkozat.pdf"; // eredeti fájlnév
        var docdfn = ""; // display fájlnév, ha üres, akkor az eredeti lesz, kiterjesztést ponttal együtt hozzáfűzi

        var docresult = this.$refs.DocDisplayer.ShowFile(docb64, docfn, docdfn);
        // grcmain_ShowFile(docb64, docfn, docdfn);

        if (docresult != "")
        {
            this.ShowResult(docresult, 200);
        }
    },


    async Init()
    {
        this.tiltva_szoveg = "";

        //console.log(GRCAPP_PostParameters);
        this.param_tagkod = 0;
        if ((GRCAPP_GetParameters.ALIAS.toLowerCase() == "pmt") && (GRCAPP_PostParameters.TAGKOD != "") && (GRCAPP_PostParameters.TAGKOD != undefined))
        {
            this.param_tagkod = parseInt(GRCAPP_PostParameters.TAGKOD);
            GRCAPP_PostParameters.TAGKOD = "";
        }

        this.param_ct = "";
        if ((GRCAPP_GetParameters.ALIAS.toLowerCase() == "pmt") && (GRCAPP_PostParameters.CT != "") && (GRCAPP_PostParameters.CT != undefined))
        {
            this.param_ct = GRCAPP_PostParameters.CT;
            GRCAPP_PostParameters.CT = "";
        }

        this.param_cv = "";
        if ((GRCAPP_GetParameters.ALIAS.toLowerCase() == "pmt") && (GRCAPP_PostParameters.CV != "") && (GRCAPP_PostParameters.CV != undefined))
        {
            this.param_cv = GRCAPP_PostParameters.CV;
            GRCAPP_PostParameters.CV = "";
        }

        
        if (this.param_tagkod == 0)
        {
            this.Tagkod = -1;
            return;
        }
        

        this.Mentve = false;

        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            iTagkod: this.param_tagkod,
            sCreateTime: this.param_ct,
            sHash: this.param_cv

        };

        //console.log(QP);
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Init_V4", QP).then(res => { Q = res; });
        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        if (Q.MISC[0].Tagkod == -2)
        {
            this.$refs.GRCDB.HideLoading();
            this.tiltva_szoveg = this.GetTextBookItem(Q.MISC[0].TiltvaSzovegCompName);
            this.Tagkod = Q.MISC[0].Tagkod;
            return;
        }

        //console.log(Q.MISC[0]);

        this.DOKTIPUSLIST = Q.DOKTIPUS;
        this.TAGADAT = Q.TAGADAT;

        this.$refs.DOKTIPUS.SetDataSource(this.DOKTIPUSLIST);
        this.$refs.DOKTIPUS.SetValue(0);

        this.MaxWidth = Q.MISC[0].MaxWidth;
        this.MaxHeight = Q.MISC[0].MaxHeight;

        this.Tagkod = Q.MISC[0].Tagkod;
        this.PdfData_Kozszereplo = Q.MISC[0].PdfData_Kozszereplo;
        this.PdfData_NemKozszereplo = Q.MISC[0].PdfData_NemKozszereplo;

        if (Q.TAGADAT.length > 0)
        {
            this.Nev = Q.TAGADAT[0].Nev;

            this.$refs.txtNev.SetText(Q.TAGADAT[0].Nev);
            this.$refs.txtSzuletesiNev.SetText(Q.TAGADAT[0].SzuletesiNev);
            this.$refs.txtAnyjaNeve.SetText(Q.TAGADAT[0].AnyjaNeve);
            this.$refs.txtSzuletesiHely.SetText(Q.TAGADAT[0].SzuletesiHely);
            this.$refs.txtSzuletesiIdo.SetText(Q.TAGADAT[0].SzuletesiIdo);
            this.$refs.txtIrszam.SetText(Q.TAGADAT[0].Irszam);
            this.$refs.txtTelepules.SetText(Q.TAGADAT[0].Telepules);
            this.$refs.txtKozterNev.SetText(Q.TAGADAT[0].KozterNev);
            this.$refs.txtKozterJelleg.SetText(Q.TAGADAT[0].KozterJelleg);
            this.$refs.txtHazszam.SetText(Q.TAGADAT[0].Hazszam);
            this.$refs.txtEpulet.SetText(Q.TAGADAT[0].Epulet);
            this.$refs.txtLepcsohaz.SetText(Q.TAGADAT[0].Lepcsohaz);
            this.$refs.txtEmelet.SetText(Q.TAGADAT[0].Emelet);
            this.$refs.txtAjto.SetText(Q.TAGADAT[0].Ajto);
        }
        else
        {
            this.Nev = "";
        }

        


        this.$refs.GRCDB.HideLoading();
        
    },


    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1; //20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.maintitle
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "PremiumDefault";
    font-size:22px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px;
}

.main_col_cont
{
    width:100%;
    box-sizing: border-box;
}

.main_col
{
    width:100%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
}

.innerform
{
    width:100%;
    box-sizing: border-box;
}

.infotext
{
    width: 100%;
    box-sizing: border-box;
    color: #323232;
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: justify;
    padding: 0px 20px 0px 0px;
}

.chkKozszerplo
{
    color: #323232;
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:500;
    text-align: left;
}


div >>> .info_title
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:18px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px 0px;
    font-weight: 500;
}


.btn_cont
{
  width:100%;
  box-sizing: border-box;
  padding:4px 0px;
  border-top:solid 0px #ccc;
  margin-top: 0px;
  text-align: left;
}

.btn
{
  display: inline-block;
  font-size: 14px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 3px;
  margin: 2px;
  min-width: 220px;
}

.btn_gray2
{
  background-color: #ccc;
  color:#222;
}

.btn:hover
{
  background-color: var(--premgreen);
  color:#fff;
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.btn_gray:hover
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.upload_headerline
{
    width: 100%;
    box-sizing: border-box;
    color: #fff;
    background-color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 16px;
    font-weight:normal;
    text-align: left;
    padding: 8px 8px 6px 8px;
    margin-bottom:0px;
}

.section_header
{
    width: 100%;
    box-sizing: border-box;
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 16px;
    font-weight:500;
    text-align: center;

    background-color: var(--premgreen);
    color: #fff;
    padding: 8px;
    font-weight: normal;    
    border-radius: 2px;
}

.dok_cont
{
    width: 100%;
    box-sizing: border-box;
    color: #323232;
    font-family: "PremiumDefault";
    margin: 10px 0px;
}


.cont_shadow
{
    /* box-shadow: #888 2px 2px 6px; */
    border: solid 0px #ccc;
    border-radius: 2px;    
}


.dokitem_table
{
    width:100%;
    height:30px;
    font-family: "PremiumDefault";
    font-size: 14px;
    line-height: 14px;
    color:#444;
    margin:8px 0px;
    border:solid 1px #ccc;
    cursor:pointer;
    background-color:#fff;
    padding:0px;
    border-radius: 2px;
}

.dokitem_fnev
{
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;    
    background-color: #fff;
    padding: 0px 4px;
    border-right: solid 1px #ccc;    
    max-width: 0;
}

.dokitem_fnev:hover
{
    background-color: #f0f0f0;
}

.dokitem_delbtn
{
    width:30px;
    text-align: center;
}

.dokitem_delbtn:hover
{
    color:red;
}


.dok_label {
    box-sizing: border-box;
    width:100%;
    font-family: "PremiumDefault", Verdana;
    font-size: 13px;
    line-height: 16px;
    padding-bottom: 5px;
    margin-top: 10px;

    background-color: #f6f6f6;
    color: #444;
    font-weight: 500;
    padding: 4px;  
    border-radius: 2px;  
    text-align: center;
    border: solid 1px #d0d0d0;    
}

.dok_label_text
{
    width:100%;
    font-size: 13px;
    line-height: 16px;
    font-family: "PremiumDefault", Verdana;
    font-weight: 500;
    min-height: 50px;
}

.innerform_pad
{
    width:100%;
    box-sizing: border-box;
    padding:4px;
}

.sikeres_text
{
    color: #323232;
    font-size: 15px;
    line-height: 20px;
    text-align: center;    
    font-weight: 500;
}

.tagnev
{
    box-sizing: border-box;
    width:100%;
    font-family: "PremiumDefault", Verdana;
    
    margin-bottom: 8px;
    background-color: #fff;
    margin-top: 0px;
    color: #323232;
    font-size: 16px;
    line-height: 16px;
    padding: 8px 4px;
    font-weight: bold;
    border: none;
    border-radius: 3px;
    text-align: center;
}

.nyilatk_info
{
    width: 100%;
    box-sizing: border-box;
    color: red;
    font-family: "PremiumDefault";
    font-size:14px;
    line-height: 18px;
    font-weight:500;
    text-align: center;
    padding-bottom: 8px;
}

.colcontent
{
    width:100%;
    box-sizing: border-box;
    padding:0px;
    margin:0px;
}

.colcontent_col2
{
    width:50%;
    box-sizing: border-box;
    padding:0px 2px;
    margin:0px;
    display:inline-block;
    vertical-align: top;
}

.colcontent_col3
{
    width:33.33%;
    box-sizing: border-box;
    padding:0px 2px;
    margin:0px;
    display:inline-block;
    vertical-align: top;
}


.htart_table
{
    width: 100%;
    box-sizing: border-box;
    display: table;    
}

.htart_tablerow
{
    display: table-row;    
}

.htart_col1
{
    width: 100%;
    box-sizing: border-box;
    padding: 10px 5px;
    display: table-cell;    
}

.htart_col2
{
    width: 50%;
    box-sizing: border-box;
    padding: 10px 5px;
    display: table-cell;    
}


@media (max-width:1020px)
{
    .infotext
    {
        font-size:14px;
        line-height: 18px;
    }

    .colcontent_col3
    {
        width:100%;
    }

}


@media (max-width:760px)
{
    .infotext
    {
        font-size:14px;
        line-height: 18px;
    }

    .colcontent_col2
    {
        width:100%;
    }

    .colcontent_col3
    {
        width:100%;
    }

    .htart_tablerow
    {
        display: block;
        box-sizing: border-box;
    }

    .htart_col1
    {
        width: 100%;
        box-sizing: border-box;
        padding: 10px 5px;
        display: block;   
    }

    .htart_col2
    {
        width: 100%;
        box-sizing: border-box;
        padding: 10px 5px;
        display: block;   
    }


}

@media (max-width:700px)
{
    .main_col
    {
        width:100%;
    }

    .infotext
    {
        font-size:14px;
        line-height: 18px;
        padding: 0px 0px 20px 0px;
    }
}


</style>